import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  max-width: 800px;
  margin: 6rem auto 4rem;
  padding: 2rem;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 4px 15px rgba(122, 73, 136, 0.1);
`;

const Title = styled.h1`
  color: #7A4988;
  font-size: 2.4rem;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const Subtitle = styled.h2`
  color: #7A4988;
  font-size: 1.6rem;
  margin-bottom: 1rem;
`;

const Text = styled.p`
  color: #555;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

function TermsOfService() {
  return (
    <PageContainer>
      <Title>Terms of Service</Title>
      
      <Section>
        <Subtitle>Acceptance of Terms</Subtitle>
        <Text>
          By using Lavender & Palm Co.’s website or services, you agree to these Terms of 
          Service and all applicable laws.
        </Text>
      </Section>

      <Section>
        <Subtitle>Orders & Payments</Subtitle>
        <Text>
          All prices are in USD and subject to change. We reserve the right to refuse service 
          or cancel orders at our discretion (e.g., suspected fraud). Payment is due at the 
          time of order placement.
        </Text>
      </Section>

      <Section>
        <Subtitle>Intellectual Property</Subtitle>
        <Text>
          All content on this site (images, designs, text) is property of Lavender & Palm Co. 
          and may not be reproduced without permission.
        </Text>
      </Section>

      <Section>
        <Subtitle>Limitation of Liability</Subtitle>
        <Text>
          Our products are provided “as is.” We are not liable for damages arising from use 
          of our site or products beyond the purchase price paid.
        </Text>
      </Section>

      <Section>
        <Subtitle>Contact</Subtitle>
        <Text>
          Questions about these terms? Reach us at <a href="mailto:lavenderandpalmco@gmail.com">lavenderandpalmco@gmail.com</a> .
        </Text>
      </Section>
    </PageContainer>
  );
}

export default TermsOfService;